export const fr = {
  // Navigation
  schedule: 'Planning',
  employees: 'Employés',
  vacations: 'Vacances et Absences',
  holidays: 'Jours Fériés',
  store: 'Magasin',
  statistics: 'Statistiques',
  export: 'Exporter',
  mySchedule: 'Mon Planning',
  
  // Common actions
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  edit: 'Modifier',
  add: 'Ajouter',
  close: 'Fermer',
  back: 'Retour',
  next: 'Suivant',
  previous: 'Précédent',
  search: 'Rechercher',
  filter: 'Filtrer',
  clear: 'Effacer',
  confirm: 'Confirmer',
  loading: 'Chargement...',
  
  // Authentication
  login: 'Connexion',
  logout: 'Déconnexion',
  username: 'Nom d\'utilisateur',
  password: 'Mot de passe',
  loginError: 'Nom d\'utilisateur ou mot de passe invalide',
  scheduleSystem: 'Système de Planning',
  loginWithCredentials: 'Connectez-vous avec votre nom d\'utilisateur et mot de passe',
  loggingIn: 'Connexion en cours...',
  testInformation: 'Informations de Test',
  
  // Store
  storeSelector: 'Sélecteur de Magasin',
  selectStore: 'Sélectionner un magasin',
  newStore: 'Nouveau Magasin',
  storeName: 'Nom du Magasin',
  address: 'Adresse',
  phone: 'Téléphone',
  email: 'Email',
  createStore: 'Créer Magasin',
  editStore: 'Modifier Magasin',
  deleteStore: 'Supprimer Magasin',
  storeCreated: 'Magasin créé avec succès',
  storeUpdated: 'Magasin mis à jour avec succès',
  storeDeleted: 'Magasin supprimé avec succès',
  storeSettings: 'Paramètres du Magasin',
  weeklySchedule: 'Planning Hebdomadaire',
  scheduleExceptions: 'Exceptions de Planning',
  addException: 'Ajouter Exception',
  editScheduleException: 'Modifier Exception de Planning',
  addScheduleException: 'Ajouter Exception de Planning',
  updateException: 'Mettre à jour Exception',
  reasonOptional: 'Raison (optionnelle)',
  openingHours: 'Heures d\'Ouverture',
  noExceptionsConfigured: 'Aucune exception configurée',
  date: 'Date',
  
  // Employees
  employeeName: 'Nom Complet',
  weeklyLimit: 'Limite Hebdomadaire (heures)',
  color: 'Couleur Employé',
  role: 'Rôle Employé',
  manager: 'Manager',
  employee: 'Employé',
  districtManager: 'Manager de District',
  employeeStartDate: 'Date de Début',
  birthday: 'Date de Naissance',
  vacationDays: 'Jours de Vacances par An',
  unavailableTimes: 'Heures Indisponibles',
  addEmployee: 'Ajouter Employé',
  editEmployee: 'Modifier Employé',
  deleteEmployee: 'Supprimer Employé',
  employeeCreated: 'Employé créé avec succès',
  employeeUpdated: 'Employé mis à jour avec succès',
  employeeDeleted: 'Employé supprimé avec succès',
  newEmployee: 'Nouvel Employé',
  regularEmployee: 'Employé Régulier',
  mainManager: 'Manager Principal',
  uniqueUsernameForLogin: 'Nom d\'utilisateur unique pour la connexion employé',
  passwordForLogin: 'Mot de passe pour la connexion employé',
  employeeList: 'Liste des Employés',
  active: 'Actif',
  inactive: 'Inactif',
  create: 'Créer',
  update: 'Mettre à jour',
  manageEmployeeInfo: 'Gérez les informations de vos employés',
  
  // Schedule
  week: 'Semaine',
  month: 'Mois',
  day: 'Jour',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  startTime: 'Heure de Début',
  endTime: 'Heure de Fin',
  hours: 'Heures',
  duration: 'Durée',
  published: 'Publier',
  draft: 'Brouillon',
  addShift: 'Créer Créneaux',
  editShift: 'Modifier Créneau',
  deleteShift: 'Supprimer Créneau',
  copyWeek: 'Copier Semaine',
  repeatWeek: 'Répéter',
  deleteWeek: 'Supprimer Semaine',
  compactMode: 'Mode Compact',
  normalMode: 'Mode Normal',
  thisWeek: 'Cette Semaine',
  copying: 'Copie en cours...',
  clickEmployeeToCreateShift: 'Cliquez sur un employé pour créer un créneau manuellement',
  view24h: 'Voir 24h',
  
  // Absences
  absenceManagement: 'Gestion des Absences',
  absenceType: 'Type d\'Absence',
  vacation: 'Vacances',
  sick: 'Maladie',
  personal: 'Personnel',
  other: 'Autre',
  absenceStartDate: 'Date de Début',
  absenceEndDate: 'Date de Fin',
  reason: 'Raison',
  status: 'Statut',
  pending: 'En Attente',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  newRequest: 'Nouvelle Demande',
  requestSubmitted: 'Demande soumise avec succès',
  remainingVacationDays: 'Jours de Vacances Restants',
  type: 'Type',
  dates: 'Dates',
  days: 'Jours',
  actions: 'Actions',
  absenceTypeLabel: 'Type d\'Absence',
  startDate: 'Date de Début',
  endDate: 'Date de Fin',
  employeeInfo: 'Informations Employé',
  requestDate: 'Date de Demande',
  approvedBy: 'Approuvé par:',
  rejectedBy: 'Rejeté par:',
  rejectionReason: 'Raison du rejet:',
  manageAllAbsenceRequests: 'Gérer toutes les demandes d\'absence',
  totalAbsences: 'Total des Absences',
  allTypes: 'Tous les types',
  allStatuses: 'Tous les statuts',
  allEmployees: 'Tous les employés',
  requestDetails: 'Détails de la Demande',
  name: 'Nom',
  absenceInformation: 'Informations d\'Absence',
  scheduleRestrictions: 'Restrictions de planning',
  shiftPendingPublication: 'créneau en attente de publication',
  shiftsPendingPublication: 'créneaux en attente de publication',
  defineOpeningHoursAndExceptions: 'Définir les heures d\'ouverture et exceptions',
  open: 'Ouvert',
  closed: 'Fermé',
  opens: 'Ouvre',
  closes: 'Ferme',
  range: 'Plage',
  addRange: 'Ajouter plage',
  addAnotherRange: 'Ajouter une autre plage',
  lastSynchronization: 'Dernière synchronisation',
  holidayInformation: 'Informations Jours Fériés',
  nationalHolidaysSyncAutomatically: 'Les jours fériés nationaux sont automatiquement synchronisés chaque année. Ces jours sont automatiquement considérés comme non ouvrables dans la planification des horaires.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Métriques de couverture et charge de travail',
  activeEmployees: 'Employés Actifs',
  shiftsThisWeek: 'Créneaux Cette Semaine',
  totalHours: 'Total des Heures',
  statisticsByEmployee: 'Statistiques par Employé',
  assignedHours: 'Heures Assignées',
  weeklyCap: 'Limite Hebdomadaire',
  utilization: '% Utilisation',
  busiestDay: 'Jour le Plus Occupé',
  daysWithoutWeekend: 'Jours Sans Weekend',
  
  // Export
  exportSchedules: 'Exporter Plannings',
  exportPublishedSchedulesInDifferentFormats: 'Exporter les plannings publiés dans différents formats',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'Aucun planning publié à exporter',
  
  // Additional UI elements
  newAbsenceRequest: 'Nouvelle Demande d\'Absence',
  selectEmployee: 'Sélectionner employé',
  describeAbsenceReason: 'Décrivez la raison de l\'absence...',
  submitting: 'Soumission en cours...',
  submitRequest: 'Soumettre Demande',
  vacationsAndAbsences: 'Vacances et Absences',
  requestVacation: 'Demander Vacances',
  newVacationRequest: 'Nouvelle Demande de Vacances',
  myVacationRequests: 'Mes Demandes de Vacances',
  clickRequestVacationToCreateFirstRequest: 'Cliquez "Demander Vacances" pour créer votre première demande',
  vacationManagement: 'Gestion des Vacances',
  vacationRequests: 'Demandes de Vacances',
  
  // Absence Types
  sickness: 'Maladie',
  unjustified: 'Absence Injustifiée',
  special: 'Congé Spécial',
  
  // Holidays
  holidayName: 'Nom du Jour Férié',
  holidayDate: 'Date du Jour Férié',
  addHoliday: 'Ajouter',
  editHoliday: 'Modifier Jour Férié',
  automaticHolidayManagement: 'Gestion automatique des jours fériés nationaux',
  addCustomHoliday: 'Ajouter Jour Férié Personnalisé',
  editCustomHoliday: 'Modifier Jour Férié Personnalisé',
  updateHoliday: 'Mettre à jour Jour Férié',
  nationalHolidays: 'Jours Fériés Nationaux',
  loadingHolidays: 'Chargement des jours fériés...',
  deleteHoliday: 'Supprimer Jour Férié',
  
  // Statistics
  totalEmployees: 'Total des Employés',
  totalShifts: 'Total des Créneaux',
  averageHours: 'Heures Moyennes',
  coverageProblems: 'Problèmes de Couverture',
  noProblems: 'Aucun problème de couverture détecté',
  gap: 'Écart',
  conflict: 'Conflit',
  overtime: 'Heures Supplémentaires',
  emptyDay: 'Aucun créneau',
  weeklyOvertime: 'Heures supplémentaires hebdomadaires',
  storeClosed: 'Magasin fermé',
  
  // Export
  exportData: 'Exporter Données',
  selectDateRange: 'Sélectionner Plage de Dates',
  from: 'De',
  to: 'À',
  exportFormat: 'Format d\'Exportation',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Données exportées avec succès',
  
  // Configuration
  configuration: 'Configuration',
  language: 'Langue de l\'Application',
  country: 'Pays (pour jours fériés)',

  // Header
  scheduleAdministrationPanel: 'Panneau d\'Administration des Plannings',
  welcome: 'Bienvenue',
  invalidDay: 'Jour invalide',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Raccourcis Clavier',
  showHideShortcutsHelp: 'Afficher/masquer l\'aide des raccourcis',
  toggleDarkMode: 'Basculer mode sombre',
  closeModalsAndPanels: 'Fermer modales et panneaux',
  openNotificationCenter: 'Ouvrir centre de notifications',
  goToScheduleTab: 'Aller à l\'onglet Planning',
  goToEmployeesTab: 'Aller à l\'onglet Employés',
  goToConfigurationTab: 'Aller à l\'onglet Configuration',
  goToStatisticsTab: 'Aller à l\'onglet Statistiques',
  goToExportTab: 'Aller à l\'onglet Export',
  createNewShift: 'Créer nouveau créneau',
  saveSchedules: 'Enregistrer plannings',
  publishSchedules: 'Publier plannings',
  navigateBetweenWeeks: 'Naviguer entre semaines',
  zoomInOut: 'Zoom avant/arrière',
  resetZoom: 'Réinitialiser zoom',
  addNewEmployee: 'Ajouter nouvel employé',
  searchEmployees: 'Rechercher employés',
  saveEmployee: 'Enregistrer employé',
  cancelEdit: 'Annuler modification',
  refreshStatistics: 'Actualiser statistiques',
  exportStatistics: 'Exporter statistiques',
  refreshSchedules: 'Actualiser plannings',
  pressCtrlSlashToShowHideHelp: 'Appuyez sur Ctrl + / pour afficher/masquer cette aide',

  // Keyboard Shortcut Categories
  general: 'Général',
  navigation: 'Navigation',
  schedules: 'Plannings',

  // Coverage Problems
  gapWithoutCoverage: 'Écart sans couverture de',
  excessiveWorkday: 'Journée de travail excessive',
  noShifts: 'Aucun créneau',
  excessiveWeeklyHours: 'Heures hebdomadaires excessives',
  problem: 'Problème',
  
  // Notifications
  notifications: 'Notifications',
  noNotifications: 'Aucune notification',
  birthdayToday: 'Anniversaire aujourd\'hui',
  reviewAssignments: 'Réviser les affectations',
  verifyAllEmployeesHaveAssignedSchedules: 'Vérifiez que tous les employés ont des plannings assignés',
  notification: 'notification',
  
  // Errors
  error: 'Erreur',
  success: 'Succès',
  warning: 'Avertissement',
  info: 'Information',
  required: 'Ce champ est requis',
  invalidDate: 'Date invalide',
  invalidTime: 'Heure invalide',
  networkError: 'Erreur réseau. Veuillez réessayer.',
  
  // Confirmations
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément?',
  confirmDeleteWeek: 'Êtes-vous sûr de vouloir supprimer tous les créneaux de cette semaine? Cette action ne peut pas être annulée.',
  confirmDeleteAll: 'Êtes-vous sûr de vouloir supprimer TOUTES les données? Cette action supprimera tous les magasins, employés et créneaux. Cette action ne peut pas être annulée.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'JJ/MM/AAAA',
  
  // Days of week
  daysOfWeek: {
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mer',
    thursday: 'Jeu',
    friday: 'Ven',
    saturday: 'Sam',
    sunday: 'Dim'
  },

  // Store Management
  storeManagement: 'Gestion des Magasins',
  welcomeSelectStore: 'Bienvenue, {name}. Sélectionnez un magasin à gérer ou créez-en un nouveau.',
  activeStores: 'Magasins Actifs',
  storeList: 'Liste des Magasins',
  generateTestData: 'Générer Données de Test',
  noStoresYet: 'Aucun magasin créé encore',
  createFirstStore: 'Créez votre premier magasin pour commencer à gérer les plannings et employés.',
  storeAddress: 'Adresse',
  storePhone: 'Téléphone',
  storeEmail: 'Email',
  storeNamePlaceholder: 'Ex: Magasin Central',
  storeAddressPlaceholder: 'Ex: Rue Principale 123',
  storePhonePlaceholder: 'Ex: +33 1 23 45 67 89',
  storeEmailPlaceholder: 'Ex: magasin@entreprise.com',
  editStoreTitle: 'Modifier Magasin',
  createStoreTitle: 'Créer Nouveau Magasin',
  storeNameRequired: 'Le nom du magasin est requis',
  confirmDeleteStore: 'Êtes-vous sûr de vouloir supprimer le magasin "{storeName}"? Cette action ne peut pas être annulée.',
  shifts: 'Créneaux',
  manageStore: 'Gérer Magasin',

  // Date Format
  dateFormat: 'Format de Date',
  dateFormatDDMMYYYY: 'JJ/MM/AAAA',
  dateFormatMMDDYYYY: 'MM/JJ/AAAA',
  dateFormatYYYYMMDD: 'AAAA/MM/JJ',

  // Employee Dashboard
  mySchedules: 'Mes Plannings',
  welcomeEmployee: 'Bienvenue, {name}',
  previousWeek: 'Semaine Précédente',
  nextWeek: 'Semaine Suivante',
  thisMonth: 'Ce Mois',
  myShifts: 'Mes Créneaux',
  shiftCalendar: 'Calendrier des Créneaux',
  list: 'Liste',
  calendar: 'Calendrier',
  noShiftsThisWeek: 'Vous n\'avez aucun créneau assigné cette semaine',
  noShiftsThisMonth: 'Vous n\'avez aucun créneau assigné ce mois',
  previousMonth: 'Mois Précédent',
  nextMonth: 'Mois Suivant',
  closeSession: 'Déconnexion'
};
